import React, { Fragment } from 'react';
import {
  CadPersonValueType,
  CadUnitsValueType
} from '../../../../../../Models/CadReportValue';
import {
  FieldItemList,
  FieldItemListType
} from '../../../CommonBody/FieldItemList/FieldItemList';
import { getCADPersonnelFullName } from '../../../CommonBody/Helpers';
import { FieldValueType } from '../../../../../../Models';

const getUnitFields = (
  unit: CadUnitsValueType,
  personnel: CadPersonValueType[]
): FieldItemListType[] => {
  let unitFields: FieldItemListType[] = [
    {
      label: 'ID',
      value: unit['id'] as string,
      type: 'string'
    },
    {
      label: 'Agency',
      value: unit['agency'] as string,
      type: 'string'
    },
    {
      label: 'Type',
      value: unit['type'] as string,
      type: 'string'
    }
  ];

  if (unit.officers_badge_ids && unit.officers_badge_ids.length > 0) {
    unitFields.push({
      label: 'Officers',
      value: unit.officers_badge_ids.map((badgeId: string) => {
        return {
          label: '',
          value: getCADPersonnelFullName(badgeId, personnel) as FieldValueType,
          type: 'string'
        };
      }),
      type: 'subList'
    });
  }

  unitFields = [
    ...unitFields,
    {
      label: 'Date and Time Arrived',
      value: unit['date_time_arrived'] as FieldValueType,
      type: 'datetime'
    },
    {
      label: 'Date and Time Cleared',
      value: unit['date_time_cleared'] as FieldValueType,
      type: 'datetime'
    }
  ];

  return unitFields;
};

export interface CadUnitsInformationProps {
  units: CadUnitsValueType[];
  personnel: CadPersonValueType[];
}

export const CadUnitsInformation = ({
  units,
  personnel
}: CadUnitsInformationProps): React.ReactElement<CadUnitsInformationProps> => {
  return (
    <Fragment>
      {units.map((unit, index) => (
        <FieldItemList
          key={unit.id}
          title={`${index === 0 ? 'Units' : ''}`}
          fields={getUnitFields(unit, personnel)}
          hasDivider={index < units.length - 1}
        />
      ))}
    </Fragment>
  );
};
